import _ from 'lodash';

export default function EquipmentDetailsService($rootScope, equipmentRepository) {
  'ngInject';

  let service = {
    get: get,
    getDetails: getDetails,
    deleteImage: deleteImage,
    getSeriesEntities: getSeriesEntities,
    filterIncludedType: filterIncludedType
  };

  function get(equipmentId, includeList, uom) {
    return equipmentRepository.getEquipment(equipmentId, null, includeList, uom).then(function(response) {
      return parse(response.data);
    });
  }

  function parse(equipmentDetails) {
    let model = {};

    try {
      let included = equipmentDetails.included;

      // we should only be using onei3 properties going forward
      model.onei3 = {};

      model.attributes = equipmentDetails.data.attributes;
      model.communicatedAt = model.attributes.communicatedAt;
      model.createdAt = model.attributes.createdAt;
      model.coordsAt = model.attributes.coordsAt;
      model.coords = model.attributes.coords;
      model.networkTechnology = model.attributes.networkTechnology;
      model.details = getDetails(equipmentDetails);
      model.device = findIncludedType('device', included);
      model.faults = getFaultData(included);
      model.id = equipmentDetails.data.id;
      model.included = included;
      model.images = filterIncludedType('image', included);
      model.installation = findIncludedType('installation', included);
      model.make = model.attributes.attrs.make;
      model.maintenancePlans = filterIncludedType('maintenancePlan', included);
      model.model = model.attributes.attrs.model;
      model.name = model.attributes.name;
      model.profileImage = getProfileImg(included, equipmentDetails.data.relationships);
      model.relationships = equipmentDetails.data.relationships;
      //getting series this way is deprecated
      model.series = getSeriesEntities(equipmentDetails);
      model.onei3.series = getOnei3Series(model.series);
      model.users = filterIncludedType('user', included);
      model.year = model.attributes.attrs.year;

      model.alerts = getAlerts(included);
      setFaultsDtcDescription(model.faults);
    } catch (err) {
      throw err;
    }

    return model;
  }

  function getOnei3Series(equipmentSeries) {
    let onei3Series = {};
    _.forEach(equipmentSeries, function(series) {
      onei3Series[series.attributes.dataId] = _.clone(series.attributes);
      onei3Series[series.attributes.dataId].id = series.id;
      onei3Series[series.attributes.dataId].meta = series.meta;
      onei3Series[series.attributes.dataId].display = series.display;
    });
    return onei3Series;
  }

  function setFaultsDtcDescription(faults) {
    faults.forEach(fault => {
      if (fault.attributes) {
        fault.dtcFaultDescriptor = equipmentRepository.getDtcFaultDescriptor(fault.attributes);
        fault.attributes.title = equipmentRepository.formatFaultCode(fault.attributes) || fault.attributes.title;
      }
    });
  }

  function deleteImage(imageId, imageIndex, equipmentDetail) {
    this.included = _.filter(this.included, function(e) {
      return e.id != imageId;
    });
  }

  function findIncludedType(type, included) {
    return !included || included.length === 0
      ? null
      : _.find(included, function(e) {
          return e.type === type;
        });
  }

  function filterIncludedType(type, included) {
    return !included
      ? []
      : _.filter(included, function(e) {
          return e.type === type;
        });
  }

  function getFaultData(included) {
    return _.filter(included, function(e) {
      return e.type === 'fault' && e.attributes && e.attributes.last && e.attributes.last.v == 1;
    });
  }

  function getAlerts(included) {
    let allAlerts = filterIncludedType('alertOccurence', included);
    let visibleAlerts = removeInvisibleAlerts(allAlerts, $rootScope.currentUser.visibleDatapoints);
    setAlertDtcDescriptor(visibleAlerts);
    return visibleAlerts;
  }

  function removeInvisibleAlerts(alerts, visibleDatapoints) {
    let visibleAlerts = [];

    _.forEach(alerts, function(alert, key) {
      let isVisible = isVisibleDatapoint(alert, visibleDatapoints);
      if (isVisible) {
        visibleAlerts.push(alert);
      }
    });

    return visibleAlerts;
  }

  function setAlertDtcDescriptor(alerts) {
    _.forEach(alerts, function(alert, key) {
      if (alert.attributes && alert.attributes.series.tags[0] === 'dtc') {
        const dtcName = equipmentRepository.getDtcFaultDescriptor(alert.attributes.series);
        alert.attributes.series.title =
          equipmentRepository.formatFaultCode(alert.attributes.series) || alert.attributes.series.title;
        if (dtcName) {
          alert.attributes.series.faultDescription = dtcName.title;
        }
      }
    });
  }

  function isVisibleDatapoint(alert, visibleDatapoints) {
    let datapoint = _.find(visibleDatapoints, function(datapoint) {
      return datapoint.id == alert.attributes.series.tags[0];
    });
    return datapoint ? true : false;
  }

  function getProfileImg(included, relationships) {
    if (relationships && relationships.profileImage) {
      return _.find(included, function(e) {
        return e.id === relationships.profileImage.data.id;
      });
    }
    return null;
  }

  function getSeriesEntities(equipmentDetails) {
    //Only get the visible series entities based on the associated datapoint display
    let visibleSeriesForUser = [];

    let equipmentSeries = filterIncludedType('series', equipmentDetails.included);

    if (equipmentSeries && equipmentSeries.length > 0) {
      let displayItems = null;

      if (
        equipmentDetails.data &&
        equipmentDetails.data.relationships &&
        equipmentDetails.data.relationships.datapointDisplay &&
        equipmentDetails.data.relationships.datapointDisplay.data &&
        equipmentDetails.data.relationships.datapointDisplay.data.attributes &&
        equipmentDetails.data.relationships.datapointDisplay.data.attributes.displayItems
      ) {
        displayItems = equipmentDetails.data.relationships.datapointDisplay.data.attributes.displayItems;
      }

      //filter out gps
      equipmentSeries = _.filter(equipmentSeries, function(e) {
        if (e.attributes.tags) {
          if (e.attributes.tags[0] === 'gps') {
            return false;
          }
        }
        return true;
      });

      if (displayItems === null) {
        return [];
      } else {
        _.forEach(equipmentSeries, function(series) {
          let matchingDisplayItem = _.find(displayItems, function(displayItem) {
            return displayItem.dataId === series.attributes.dataId;
          });

          if (series.attributes.descriptor && series.attributes.descriptor.title) {
            series.attributes.title = series.attributes.descriptor.title;
          }
          if (matchingDisplayItem) {
            series.display = matchingDisplayItem.visible;
            series.order = matchingDisplayItem.ordinal;
            series.keyMetric = matchingDisplayItem.keyMetric;
            series.decimals = matchingDisplayItem.decimals;
            visibleSeriesForUser.push(series);
          } else {
            series.display = false;
            series.order = 999;
            series.keyMetric = false;
            visibleSeriesForUser.push(series);
          }
        });
      }
    }

    return _.sortBy(visibleSeriesForUser, function(series) {
      return series.order;
    });
  }

  function getDetails(equipment) {
    let attrTable = createAttributeTable(equipment);
    return createDetailsList(equipment.data.attributes.attrs, attrTable);
  }

  function createDetailsList(equipmentAttributes, attrTable) {
    let details = [];
    for (let key in equipmentAttributes) {
      if (equipmentAttributes.hasOwnProperty(key) && key.indexOf('onei3:') === -1) {
        let value = equipmentAttributes[key];
        let detail = {
          key: key,
          value: value,
          dataType: null
        };
        if (attrTable[key.toLowerCase()]) {
          detail.dataType = attrTable[key.toLowerCase()].attributes.dataType;
        }
        details.push(detail);
      }
    }

    return details;
  }

  function createAttributeTable(equipmentData) {
    let attributes = filterIncludedType('attribute', equipmentData.included);
    let keyed = _.indexBy(attributes, function(o) {
      return o.attributes.key.toLowerCase();
    });
    return keyed;
  }

  return service;
}
